var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.3 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    strokeMiterlimit: 10,
    d: "M28.8 40.7c.7-1.2 1.6-3.4 2.7-2.6 1.4 1 3 1.8 4.7 2.3v-7.2c-3.5-1.4-7.5-3.4-7.5-8.4 0-3.6 2.4-6.7 7.5-7.1v-1.2c0-.4.3-.7.7-.7h.5c.4 0 .7.3.7.7v1.2c2.4.2 4.6 1.1 6.5 2.4.4.3.5.8.2 1.2-.8 1.1-1.8 3.2-2.7 2.6-1.3-.8-2.6-1.5-4.1-2v6.7c3.3 1.4 7.8 3.6 7.8 8.5 0 4.1-2.8 7.1-7.8 7.4v3.9c0 .4-.3.7-.7.7h-.1c-.5 0-1.2 0-1.2-.7v-3.9c-2.6-.2-5.1-1.2-7.1-2.9-.3-.1-.5-.3-.1-.9zm7.3-18.8c-1.9.2-2.8 1.3-2.8 2.4 0 1.5.9 2.6 2.8 3.6zm4.8 16c0-1.5-.9-2.7-2.8-3.8v6.6c1.5-.1 2.7-1.3 2.8-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M37.2 1.5c-16.6 0-30 13.4-30 30m29 30c16.6 0 30-13.4 30-30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M13.4 25.2 7.2 35.3 1.5 24.9M60 37.8l6.2-10.2L71.8 38"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.3a5d8e2ab35731091e39c74d79abf2c3.svg";
export { ForwardRef as ReactComponent };